import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {ViewComponent} from '@modules/cy/patient/orcd/create/pages/view/view.component';
import {physicianGuard} from '@app/auth/guards/physician.guard';
import {CreateComponent} from '@modules/cy/patient/orcd/create/pages/create/create.component';

export const CreateRoutes: Routes = [
  {
    path: '',
    component: ViewComponent,
    canActivate: [physicianGuard]
  },
  {
    path: 'create',
    component: CreateComponent,
    canActivate: [physicianGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(CreateRoutes)],
  exports: [RouterModule]
})
export class CreateRoutingModule { }
